<template>
  <div class="import-reviews-hero text-center rounded px-base py-10 mb-base">
    <h3 class="font-bold mb-4 import-reviews-hero__title">New: Hand-pick reviews, instead of waiting for imports</h3>
    <p class="import-reviews-hero__body mb-4 mx-auto">
      As many of our users will know, over the last few years, our review imports partner platform has become unreliable, which left us with little choice but to switch off scheduled review imports.
    </p>
    <p class="import-reviews-hero__body text-xl font-semibold mb-6 mx-auto">
      Instead, you can now add reviews yourself with our free Chrome extension. Click the <span class="font-semibold">Import Reviews</span> button below to install it, then click any review on the review site — it's added to your widgets <span class="import-reviews-hero__instant">instantly</span>. You'll see it under <span class="font-semibold">"On Showcase"</span> on the <router-link to="/dash/showcase" class="text-primary font-semibold">Showcase page</router-link>.
    </p>
    <div class="import-reviews-hero__video mx-auto mb-6">
      <div class="import-reviews-hero__video-embed">
        <iframe
          src="https://customer-n548bbvvl783tp8n.cloudflarestream.com/14cbe5331f679cfb71b5e3668efad956/iframe?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-n548bbvvl783tp8n.cloudflarestream.com%2F14cbe5331f679cfb71b5e3668efad956%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
          loading="lazy"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowfullscreen="true"
        ></iframe>
      </div>
      <p class="import-reviews-hero__video-caption">Watch the 1-minute walkthrough</p>
    </div>
    <vs-button class="inline-block" size="large" icon-pack="feather" icon="icon-download" @click="open">Import Reviews</vs-button>
  </div>
</template>

<script>
export default {
  name: 'ImportReviewsAlert',
  // v-model: parent owns the modal open/close flag; this component flips it
  // to true when the button is clicked.
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Boolean, default: false }
  },
  methods: {
    open() {
      this.$emit('input', true)
    }
  }
}
</script>

<style scoped>
.import-reviews-hero {
  background: #f0eefe;
  border: 1px solid #7367f0;
}
.import-reviews-hero__title {
  font-size: 1.5rem;
  line-height: 1.3;
  color: #2c2c2c;
}
.import-reviews-hero__body {
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.55;
  color: #3a3a3a;
  max-width: 720px;
}
.import-reviews-hero__apology {
  max-width: 720px;
}
.import-reviews-hero__instant {
  font-weight: 700;
  color: #7367f0;
  border-bottom: 2px solid #7367f0;
  padding-bottom: 1px;
}
.import-reviews-hero__video {
  max-width: 640px;
}
.import-reviews-hero__video-embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.18);
}
.import-reviews-hero__video-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.import-reviews-hero__video-caption {
  margin-top: 0.6rem;
  font-size: 0.95rem;
  color: #555;
  font-style: italic;
}
</style>
